import React, { Suspense, lazy } from 'react';
import { Header } from './components/ToxicDetector/Header';
import { HeroSection } from './components/ToxicDetector/HeroSection';
import { TrustSection } from './components/ToxicDetector/TrustSection';
import { Footer } from './components/ToxicDetector/Footer';
import { MetaTags } from './components/SEO/MetaTags';
import { ProStatusListener } from './components/ProStatusListener';
import { LazySection } from './components/LazySection';
// Lazy-load every below-the-fold section. Each gets its own
// LazySection wrapper which adds IntersectionObserver + its own Suspense
// boundary, so chunks are only requested as the user scrolls near them.
const SocialProofSection = lazy(() => import('./components/ToxicDetector/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const CredentialsImageSection = lazy(() => import('./components/ToxicDetector/CredentialsImageSection').then(m => ({
  default: m.CredentialsImageSection
})));
const HiddenToxicitySection = lazy(() => import('./components/ToxicDetector/HiddenToxicitySection').then(m => ({
  default: m.HiddenToxicitySection
})));
const DetectionImageSection = lazy(() => import('./components/ToxicDetector/DetectionImageSection').then(m => ({
  default: m.DetectionImageSection
})));
const ToxicityAuditSection = lazy(() => import('./components/ToxicDetector/ToxicityAuditSection').then(m => ({
  default: m.ToxicityAuditSection
})));
const WarningImageSection = lazy(() => import('./components/ToxicDetector/WarningImageSection').then(m => ({
  default: m.WarningImageSection
})));
const FeaturesSection = lazy(() => import('./components/ToxicDetector/FeaturesSection').then(m => ({
  default: m.FeaturesSection
})));
const ShareYourStorySection = lazy(() => import('./components/ToxicDetector/ShareYourStorySection').then(m => ({
  default: m.ShareYourStorySection
})));
const GuaranteesSection = lazy(() => import('./components/ToxicDetector/GuaranteesSection').then(m => ({
  default: m.GuaranteesSection
})));
const IntroImageSection = lazy(() => import('./components/ToxicDetector/IntroImageSection').then(m => ({
  default: m.IntroImageSection
})));
const ToolsSection = lazy(() => import('./components/ToxicDetector/ToolsSection').then(m => ({
  default: m.ToolsSection
})));
const ComparisonSection = lazy(() => import('./components/ToxicDetector/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const PricingSection = lazy(() => import('./components/ToxicDetector/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/ToxicDetector/FAQSection').then(m => ({
  default: m.FAQSection
})));
const JourneyImageSection = lazy(() => import('./components/ToxicDetector/JourneyImageSection').then(m => ({
  default: m.JourneyImageSection
})));
const CTASection = lazy(() => import('./components/ToxicDetector/CTASection').then(m => ({
  default: m.CTASection
})));
const SEONavigationSection = lazy(() => import('./components/ToxicDetector/SEONavigationSection').then(m => ({
  default: m.SEONavigationSection
})));
// Lazy-load non-critical UI that appears after user interaction or scroll
const PromoBanner = lazy(() => import('./components/Notifications/PromoBanner').then(m => ({
  default: m.PromoBanner
})));
export function App() {
  return <>
      <ProStatusListener data-id="element-19" data-mp="1w2aq470zbk3s" />
      <MetaTags data-id="element-20" data-mp="1w2kj83hbm7dp" />
      <Suspense fallback={null} data-id="element-21" data-mp="1w0znwbn6mkes">
        <PromoBanner data-id="element-22" data-mp="1i442rktnp2id" />
      </Suspense>
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-23" data-mp="1i319x7crwpzt">
        <Header data-id="element-24" data-mp="1m3l8mfczw1o2" />
        <main data-id="element-25" data-mp="1m790zb6pei17">
          {/* Above the fold — eager loaded so first paint is instant. */}
          <HeroSection data-id="element-26" data-mp="6n4auqb80pov" />
          <TrustSection data-id="element-27" data-mp="aq0xcs3vt5y3" />

          {/* Below the fold — each section streams in independently
           via IntersectionObserver + its own Suspense boundary. */}
          <LazySection minHeight={520} data-id="element-28" data-mp="qyqedy040pd3">
            <SocialProofSection data-id="element-29" data-mp="m6p3afeoh4on" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-30" data-mp="m4udonsgooe8">
            <CredentialsImageSection data-id="element-31" data-mp="h72q25yunofu" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-32" data-mp="h7lxutuscwg5">
            <HiddenToxicitySection data-id="element-33" data-mp="c8j3q4gcgamy" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-34" data-mp="ca2itrq9kfn5">
            <DetectionImageSection data-id="element-35" data-mp="19vrlbod84zjo" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-36" data-mp="19v88un6cf3d1">
            <ToxicityAuditSection data-id="element-37" data-mp="14wewwz6pfkez" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-38" data-mp="14uu1z8gh9zgl">
            <WarningImageSection data-id="element-39" data-mp="zxanc7fvbko4" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-40" data-mp="zzww2aehw67x">
            <FeaturesSection data-id="element-41" data-mp="vwrv4ca2ccle" />
          </LazySection>
          <LazySection minHeight={620} data-id="element-42" data-mp="vvyrvlabc580">
            <ShareYourStorySection data-id="element-43" data-mp="3kokk9alp8wxs" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-44" data-mp="3klyd3c2q0jg3">
            <GuaranteesSection data-id="element-45" data-mp="3glxz1sjjaa9k" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-46" data-mp="3gok7rvi5uvtd">
            <IntroImageSection data-id="element-47" data-mp="1w4yl8474u013" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-48" data-mp="1w2c2d8esjy3k">
            <ToolsSection data-id="element-49" data-mp="205ih74fyyxln" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-50" data-mp="206a0pgwal4vk">
            <ComparisonSection data-id="element-51" data-mp="255d837zqvn6p" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-52" data-mp="253scrg5lw07s">
            <PricingSection data-id="element-53" data-mp="29vjwb6qch5of" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-54" data-mp="29xejkrp399vo">
            <FAQSection data-id="element-55" data-mp="2ev6jo8zw02ay" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-56" data-mp="2euenox2do2k5">
            <JourneyImageSection data-id="element-57" data-mp="2jtzn18lgmcxe" />
          </LazySection>
          <LazySection minHeight={500} data-id="element-58" data-mp="2jsg4tcg8trsz">
            <CTASection data-id="element-59" data-mp="2nvl5rakodlfi" />
          </LazySection>
          <LazySection minHeight={300} data-id="element-60" data-mp="2nww959a7kr63">
            <SEONavigationSection data-id="element-61" data-mp="2nts120tmhba5" />
          </LazySection>
        </main>
        <Footer data-id="element-62" data-mp="2stwh5pqmc3zu" />
      </div>
    </>;
}